import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "@nimbus-ds/styles/dist/index.css";
import MainHome from "./Components/MainHome";
import CustomCredentials from "./Components/CustomCredentials";
import CustomTableHeader from "./Components/CustomTableHeader";
import { connect, iAmReady, getStoreInfo } from "@tiendanube/nexo";
import nexo from "./NexoClient";
import { LanguageProvider } from "./context/LanguageContext";

const App: React.FC = () => {
  const [isConnect, setIsConnect] = useState(false);
  const [storeInfo, setStoreInfo] = useState<any>({});
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [unclassifiedCount, setUnclassifiedCount] = useState<number>(0);
  const [totalItemsCount, setTotalItemsCount] = useState<number>(0);

  useEffect(() => {
    connect(nexo).then(async () => {
      setIsConnect(true);
      iAmReady(nexo);
    });
    getStoreInfo(nexo).then(async (data: any) => {
      setStoreInfo(data);
    });
  }, []);

  if (!isConnect) return <div>connecting..</div>;

  return (
    <LanguageProvider initialLocale={storeInfo.language}>
      <Router>
        <Routes>
          <Route path="/" element={<MainHome storeInfo={storeInfo} />} />
          <Route
            path="/manage-credentials"
            element={<CustomCredentials storeInfo={storeInfo} />}
          />
          <Route
            path="/manage-products"
            element={
              <CustomTableHeader
                onSearchChange={(e) => setSearchQuery(e.target.value)}
                searchQuery={searchQuery}
                onUnclassifiedCountChange={setUnclassifiedCount}
                onTotalItemsCountChange={setTotalItemsCount}
                storeInfo={storeInfo}
              />
            }
          />
        </Routes>
      </Router>
    </LanguageProvider>
  );
};

export default App;
